import { useIntl } from "react-intl";

import { usePatientName } from "src/features/patient";
import { genericMessages, yesNoMessages } from "src/messages/generic";
import { useAddress } from "src/modules/htx/header/hooks/useAddress";
import { useAge } from "src/modules/htx/header/hooks/useAge";
import { useBloodGroup } from "src/modules/htx/header/hooks/useBloodGroup";
import { useBmi } from "src/modules/htx/header/hooks/useBmi";
import { useCombinedTransplant } from "src/modules/htx/header/hooks/useCombinedTransplant";
import { useDateOfBirth } from "src/modules/htx/header/hooks/useDateOfBirth";
import { useHeight } from "src/modules/htx/header/hooks/useHeight";
import { useHyperImmunised } from "src/modules/htx/header/hooks/useHyperImmunised";
import { useLongStatus } from "src/modules/htx/header/hooks/useLongStatus";
import { useMaidenNameOfMother } from "src/modules/htx/header/hooks/useMaidenNameOfMother";
import { usePatientEtId } from "src/modules/htx/header/hooks/usePatientEtId";
import { usePhoneNumber } from "src/modules/htx/header/hooks/usePhoneNumber";
import { usePvr } from "src/modules/htx/header/hooks/usePvr";
import { useSocialSecurityNumber } from "src/modules/htx/header/hooks/useSocialSecurityNumber";
import { useThoracotomia } from "src/modules/htx/header/hooks/useThoracotomia";
import { useWaitingListTime } from "src/modules/htx/header/hooks/useWaitingListTime";
import { useWeight } from "src/modules/htx/header/hooks/useWeight";
import { messages } from "src/modules/htx/header/messages";

export function useHeaderValues(): { label?: string; value?: string }[] {
	const { formatMessage } = useIntl();

	const name = usePatientName();
	const maidenNameOfMother = useMaidenNameOfMother();
	const status = useLongStatus();
	const { value: waitingList } = useWaitingListTime();
	const { value: patientEtId } = usePatientEtId();
	const ssn = useSocialSecurityNumber();
	const address = useAddress();
	const phoneNumber = usePhoneNumber();
	const { value: thoracotomia } = useThoracotomia();
	const { value: bloodGroup } = useBloodGroup();
	const dateOfBirth = useDateOfBirth();
	const age = useAge();
	const { value: weight } = useWeight();
	const { value: height } = useHeight();
	const { value: bmi } = useBmi();
	const { value: pvr } = usePvr();
	const { value: combinedTransplant } = useCombinedTransplant();
	const { value: hyperImmunised } = useHyperImmunised();

	return [
		{ label: formatMessage(messages.name), value: name },
		{
			label: formatMessage(messages.maidenNameOfMother),
			value: maidenNameOfMother
		},
		{ label: formatMessage(messages.status), value: status },
		{
			label: formatMessage(messages.waitingList),
			value:
				waitingList === undefined
					? "-"
					: formatMessage(genericMessages.days, { days: waitingList })
		},
		{ label: formatMessage(messages.patientEtId), value: patientEtId },
		{ label: formatMessage(messages.ssn), value: ssn },
		{ label: formatMessage(messages.address), value: address },
		{ label: formatMessage(messages.phoneNumber), value: phoneNumber },
		{ label: formatMessage(messages.thoracotomia), value: thoracotomia },
		{ label: formatMessage(messages.bloodGroup), value: bloodGroup },
		{ label: formatMessage(messages.dateOfBirth), value: dateOfBirth },
		{ label: formatMessage(messages.age), value: age },
		{ label: formatMessage(messages.weight), value: weight },
		{ label: formatMessage(messages.height), value: height },
		{ label: formatMessage(messages.bmi), value: bmi },
		{ label: formatMessage(messages.pvr), value: pvr },
		{
			label: formatMessage(messages.combinedTransplant),
			value: combinedTransplant ? formatMessage(yesNoMessages.YES) : "-"
		},
		{
			label: formatMessage(messages.hyperImmunised),
			value: hyperImmunised ? formatMessage(yesNoMessages.YES) : "-"
		}
	];
}
